@if (displayError(); as error) {
	<div class="form-message-text error">
		{{error}}
	</div>
}
@if (serverResponse(); as response) {
	<div class="form-message-text center">
		{{response.toString()}}
	</div>
}
